import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersEmployeeConditionSubmissionsDestroyResponseType } from "~/domains";

type RequestDataType = {
  id: string;
  employeeConditionSurveyId: string;
};

const request = ({ id, employeeConditionSurveyId }: RequestDataType) => {
  return new ApiClient()
    .delete<ApiMembersEmployeeConditionSubmissionsDestroyResponseType>(
      `/api/members/employee_condition_surveys/${employeeConditionSurveyId}/employee_condition_submissions/${id}`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApiMembersEmployeeConditionSubmissionsDestroy = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersEmployeeConditionSubmissionsDestroyResponseType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
